// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.YZvrpIqhUdrT9P {
  position: relative;
  width: auto;
  height: 132px;
  border-radius: 3px;
}
.LJ2MPxkzHHMNZ6 {
  content: ' ';
  position: relative;
  width: 100%;
  height: 132px;
  margin-top: -132px;
  transition: opacity 0.2s ease-in-out;
  border-radius: 3px;
  box-shadow: var(--ds-shadow-overlay, 0px 8px 12px #091e4226, 0px 0px 1px #091e424f);
}
.m_UDuilNHL5OXt {
  position: relative;
  margin-top: -36px;
  padding-right: 12px;
  padding-bottom: 12px;
  padding-left: 12px;
}
.W8ZKBojd0onX0O {
  border-width: 3px;
  border-style: solid;
  border-color: var(--ds-border-inverse, #ffffff);
  background-color: var(--ds-background-accent-gray-subtlest, #f1f2f4);
  box-shadow: var(--ds-shadow-raised, 0px 1px 1px #091e4240, 0px 0px 1px #091e424f);
}
.hKHE7Wu0qlR7ER {
  border-radius: 3px;
}
.XrVbBzN46R0Pdt {
  line-height: 12px;
}
.KuBD3xE7sXgEaG {
  margin-top: 12px;
  color: var(--ds-text, #172b4d);
  font-size: 14px;
  font-weight: bold;
  line-height: 20px;
}
.wlqVK9ixvnKFab {
  color: var(--ds-text-subtle, #44546f);
  font-size: 12px;
  line-height: 20px;
}
.fFePKJ55S42L7_ {
  color: var(--ds-text, #172b4d);
  font-size: 12px;
  line-height: 20px;
}
.zGIoSM8A7yx_Xg {
  flex: 1 0 31%;
  max-width: 32%;
  min-height: 269px;
  margin-right: 2%;
  margin-bottom: 24px;
}
.zGIoSM8A7yx_Xg:nth-of-type(3n) {
  margin-right: 0;
}
@media only screen and (min-width: 751px) and (max-width: 900px) {
  .zGIoSM8A7yx_Xg {
    flex: 1 0 48%;
    max-width: 49%;
  }
  .zGIoSM8A7yx_Xg:nth-of-type(3n) {
    margin-right: 2%;
  }
  .zGIoSM8A7yx_Xg:nth-of-type(2n) {
    margin-right: 0;
  }
  .zGIoSM8A7yx_Xg.L196m0NsQlzK7B:nth-of-type(3n) {
    display: none;
  }
}
@media only screen and (max-width: 750px), only screen and (max-width: 450px) {
  .zGIoSM8A7yx_Xg {
    flex: auto;
    width: 100%;
    max-width: none;
    height: auto;
    margin-right: 0;
  }
}
.rjXziox0N8NWTB {
  display: block;
  width: 100%;
  text-decoration: none;
  cursor: pointer;
}
.rjXziox0N8NWTB:hover {
  text-decoration: none;
}
.IsunyN72E2v79P {
  margin-top: 10px;
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"templateBackground": `YZvrpIqhUdrT9P`,
	"templateBackgroundAfter": `LJ2MPxkzHHMNZ6`,
	"templateInfo": `m_UDuilNHL5OXt`,
	"avatar": `W8ZKBojd0onX0O`,
	"orgAvatar": `hKHE7Wu0qlR7ER`,
	"memberAvatar": `XrVbBzN46R0Pdt`,
	"title": `KuBD3xE7sXgEaG`,
	"author": `wlqVK9ixvnKFab`,
	"blurb": `fFePKJ55S42L7_`,
	"tileContainer": `zGIoSM8A7yx_Xg`,
	"isFeatured": `L196m0NsQlzK7B`,
	"allText": `rjXziox0N8NWTB`,
	"viewsAndCopies": `IsunyN72E2v79P`
};
export default ___CSS_LOADER_EXPORT___;
